// @core/api/endpoints/document/assign_document_number.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AssignDocumentNumberRequest,
  DocumentLifecycleResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Assign document number
 * Assigns a document number to an entity using the configured numbering scheme. Called automatically on creation if scheme is configured, or manually.
 */
export async function AssignDocumentNumber(
  target_type: string,
  target_id: string,
  data: AssignDocumentNumberRequest,
  options?: RequestOptions
): Promise<DocumentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/assign-number`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<DocumentLifecycleResponse>(requestPath, data, requestOptions);
}
